import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup } from '@angular/forms';

@Pipe({
    name: 'formControlFromFormGroup',
    standalone: false
})
export class FormControlFromFormGroupPipe implements PipeTransform {
	/**
	 * Returns a specific FormControl from the given FormGroup or AbstractControl
	 * An AbstractControl can be passed in, and it will be cast to a FormGroup, so make sure it's not a FormArray
	 * This pipe is needed because the input-components (see e.g. {@link InputComponent}) expect a form-control,
	 * but accessing FormControls in the template always return an AbstractControl and templates don't allow for type-casting
	 * @param desiredFormControlName The name of the desired form-control
	 * @param formGroup The FormGroup the control should be extracted from
	 * @return Returns the requested FormControl of the given FormGroup. Or Null if it is not found
	 */
	transform(desiredFormControlName: string, formGroup: UntypedFormGroup | AbstractControl): UntypedFormControl {
		return (formGroup as UntypedFormGroup).get(desiredFormControlName) as UntypedFormControl;
	}

}
